module.exports = __webpack_public_path__ + "static/media/404publicblog.cbf7df2e.png";